import {Component, OnInit, TemplateRef} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {ContentHeaderService} from '../../services/content-header.service';

@Component({
  selector: 'app-content-header',
  imports: [
    NgTemplateOutlet
  ],
  templateUrl: './content-header.component.html',
})
export class ContentHeaderComponent implements OnInit {
  public contentRef: TemplateRef<string> | null = null;

  public constructor(
    private contentHeaderService: ContentHeaderService,
  ) {}

  public ngOnInit() {
    this.contentHeaderService.content$.subscribe({
      next: value => {
        this.contentRef = value;
      }
    });
  }
}
